import Decoder from 'jsonous'
import * as _ from 'jsonous'
import { err, ok } from 'resulty'

import type { CornerStatus, EatPlace, OrderStatus } from './store/types'

export const parseEatPlace = (eat_place: EatPlace, car_number: string | null, table: number | null) =>
  eat_place === 'car'
    ? `к машине (${car_number})`
    : eat_place === 'market_table'
    ? `На рынке к столу ${table}`
    : eat_place === 'market_corner'
    ? 'на подносе'
    : eat_place === 'togo_corner'
    ? 'С собой (на стойке корнера)'
    : eat_place === 'togo_courier'
    ? 'С собой(у раннера)'
    : eat_place === 'togo_market'
    ? 'со стойки HN'
    : eat_place === 'togo_delivery'
    ? 'доставка'
    : eat_place === 'togo_yandex'
    ? 'Яндекс'
    : eat_place === 'togo_sber'
    ? 'Купер'
    : eat_place === 'consumer'
    ? `В термах к столу ${table}`
    : '!'

export const monthList = [
  'январь',
  'февраль',
  'март',
  'апрель',
  'май',
  'июнь',
  'июль',
  'август',
  'сентябрь',
  'октябрь',
  'ноябрь',
  'декабрь',
]

export const getDateString = () => {
  const today = new Date()

  const day = today.getDate()
  const month = today.getMonth()
  const year = today.getFullYear()

  return `${day} ${monthList[month]} ${year}`
}

export const getTimeString = (time: number) => {
  const date = new Date(time * 1000)

  const hours = date.getHours()
  const minutes = `0${date.getMinutes()}`

  return `${hours}:${minutes.substr(-2)}`
}

export const translateToStyleCorner = (status: CornerStatus) =>
  status === 'waiting'
    ? 'не принят'
    : status === 'confirmed'
    ? 'принял'
    : status === 'refused'
    ? 'отклонил'
    : status === 'expects'
    ? 'ожидает'
    : status === 'cooking'
    ? 'готовится'
    : status === 'ready'
    ? 'готов'
    : status === 'waiting_on_counter'
    ? 'на стойке корнера'
    : status === 'issued_courier'
    ? 'у раннера'
    : status === 'received'
    ? 'выдан'
    : ''

export const translateToStyleOrder = (status: OrderStatus) =>
  status === 'waiting'
    ? 'не принят'
    : status === 'confirmed'
    ? 'принят'
    : status === 'refused'
    ? 'отклонён'
    : status === 'expects'
    ? 'в процессе'
    : status === 'cooking'
    ? 'в процессе'
    : status === 'ready'
    ? 'готов'
    : status === 'issued_courier'
    ? 'у раннера'
    : status === 'waiting_on_counter'
    ? 'ожидает клиента'
    : status === 'received'
    ? 'заказ выдан клиенту'
    : ''

export const nullOr = <T>(decoder: Decoder<T>): Decoder<T | null> =>
  new Decoder<T | null>((val: unknown) => (val === null ? ok(val) : decoder.decodeAny(val)))

export const numToBool = new Decoder<boolean>((val: unknown) =>
  val === null || val === 0 ? ok(false) : typeof val === 'number' ? ok(true) : err('Should be number or NULL'),
)

export const stringToNum = new Decoder<number>((val: unknown) =>
  typeof val === 'number' ? ok(val) : typeof val === 'string' ? ok(Number(val)) : err('Should be any number or string'),
)

export const decodeAndGet = <T>(decoder: Decoder<T>, payload: unknown): [T | undefined, string] =>
  decoder.decodeAny(payload).cata<[T | undefined, string]>({
    Ok: (val) => [val, ''],
    Err: (msg) => [undefined, msg],
  })

export const playSound = (audioFile: { play: () => any }) => {
  return audioFile.play()
}

export const isRecord = (obj: unknown): obj is Record<PropertyKey, unknown> => obj !== null && typeof obj === 'object'

export const optionalField = <T>(fieldName: string, decoder: Decoder<T>, defaultValue: T): Decoder<T> =>
  new Decoder((val: unknown) =>
    isRecord(val) && fieldName in val ? decoder.decodeAny(val[fieldName]) : ok(defaultValue),
  )

export const objectArray = <T>(decoder: Decoder<T>): Decoder<T[]> =>
  new Decoder((val: unknown) =>
    isRecord(val) ? _.array(decoder).decodeAny(Object.values(val)) : err('что-то не так с объектом заказов'),
  )
